import { Button, Textfield } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import type { CrmProvider } from "../../types/types";
import { ConfirmationModal } from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/ConfirmationModal";
import {
    StyledConfirmationModalButtonsContainer,
    StyledConfirmationModalLabel,
} from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/styles";

type CrmEnrichmentJobNameModalProps = {
    isOpened: boolean;
    onClose: () => void;
    jobName: string;
    isSubmitDisabled: boolean;
    isSubmitLoading: boolean;
    isRenameMode?: boolean;
    crmProvider: CrmProvider;
    onChangeJobName: (name: string) => void;
    onSaveName: (name: string) => void;
};

const CrmEnrichmentJobNameModal = ({
    isOpened,
    onClose,
    jobName,
    onChangeJobName,
    onSaveName,
    isSubmitDisabled,
    isSubmitLoading,
    isRenameMode,
    crmProvider,
}: CrmEnrichmentJobNameModalProps) => {
    const titleKey = isRenameMode
        ? `si.crm-enrichment.name-modal.header.rename`
        : `si.crm-enrichment.name-modal.header`;

    return (
        <ConfirmationModal
            isOpened={isOpened}
            titleKey={titleKey}
            dataAutomation={`${crmProvider}-enrichment-job-name-modal`}
        >
            <I18n
                element={StyledConfirmationModalLabel}
                translatable={{
                    key: `si.crm-enrichment.name-modal.label`,
                }}
            />
            <Textfield
                defaultValue={jobName}
                onChange={(value) => onChangeJobName(value)}
                placeholder={translate(`si.crm-enrichment.name-modal.placeholder`)}
                autoFocus
            />
            <StyledConfirmationModalButtonsContainer>
                <Button
                    onClick={onClose}
                    type="flat"
                >
                    {translate(isRenameMode ? "si.common.button.cancel" : "si.common.button.back")}
                </Button>
                <Button
                    onClick={() => onSaveName(jobName)}
                    isDisabled={isSubmitDisabled}
                    isLoading={isSubmitLoading}
                >
                    {translate(isRenameMode ? "si.common.button.rename" : "common.done")}
                </Button>
            </StyledConfirmationModalButtonsContainer>
        </ConfirmationModal>
    );
};

export default CrmEnrichmentJobNameModal;
